const { lighten } = require('@mui/material');
const { makeStyles } = require('@mui/styles');


const useStylesSortableTable = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paginationRoot: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    '& > *': {
      marginTop: theme.spacing(2),
    },
    '& li:first-of-type': {
      transform: 'rotate(180deg)',
    },
    '& li:last-of-type': {
      transform: 'rotate(180deg)',
    },
  },
  formControl: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    margin: theme.spacing(1),
    minWidth: 140,
  },
  countPerpage: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(2),
  },
  selectInput: {
    minWidth: 80,
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
    backgroundColor: lighten(theme.palette.background.paper, 0.1),
  },
  table: {
    minWidth: 750,
    '& td': {
      padding: '6px 16px !important',
    },
    '& .noPadding': {
      padding: '0px 16px !important',
    },

  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

export default useStylesSortableTable;
